import { createAsyncThunk } from "@reduxjs/toolkit";
import { preLoginService } from "../../Services";
import { alert } from "../../utils/commonFunctions/alert";

const getUserId = () => {
    try {
        const u = JSON.parse(localStorage.getItem("user"));
        return u?.id ?? null;
    } catch {
        return null;
    }
};

// GET /api/notifications/user/:userId?page&limit
export const fetchUserNotifications = createAsyncThunk(
    "notifications/fetchUserNotifications",
    async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
        try {
            const userId = getUserId();
            if (!userId) return rejectWithValue("User not found. Please login again.");

            const url = `/api/notifications/user/${userId}?page=${page}&limit=${limit}`;
            const res = await preLoginService.get(url);

            return res?.data ?? res;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || err?.message || "Fetch failed");
        }
    }
);


// GET /api/notifications/user/:userId/unread-count
export const fetchUnreadCount = createAsyncThunk(
    "notifications/fetchUnreadCount",
    async (_, { rejectWithValue }) => {
        try {
            const userId = getUserId();
            if (!userId) return rejectWithValue("User not found. Please login again.");

            const url = `/api/notifications/user/${userId}/unread-count`;
            const res = await preLoginService.get(url);

            // usually { unreadCount: number }
            return res?.data ?? res;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || err?.message || "Unread count failed");
        }
    }
);
// PATCH /api/notifications/:id/toggle-read
export const toggleNotificationRead = createAsyncThunk(
    "notifications/toggleNotificationRead",
    async ({ id }, { rejectWithValue }) => {
        try {
            const url = `/api/notifications/${id}/toggle-read`;
            const res = await preLoginService.patch(url);
            return { id, updated: res };
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || "Failed to toggle notification"
            );
        }
    }
);

// PATCH /api/notifications/:id/mark-read
export const markNotificationRead = createAsyncThunk(
    "notifications/markNotificationRead",
    async ({ id }, { rejectWithValue }) => {
        try {
            const url = `/api/notifications/${id}/mark-read`;
            const res = await preLoginService.patch(url);
            return { id, updated: res };
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || "Failed to mark as read"
            );
        }
    }
);

// PATCH /api/notifications/user/:userId/mark-all-read
export const markAllNotificationsRead = createAsyncThunk(
    "notifications/markAllNotificationsRead",
    async (_, { rejectWithValue }) => {
        try {
            const userId = getUserId();
            if (!userId) return rejectWithValue("User not found. Please login again.");

            const url = `/api/notifications/user/${userId}/mark-all-read`;
            const res = await preLoginService.patch(url);

            // alert.success("All notifications marked as read");
            return res;
        } catch (error) {
            alert.error("Mark all read failed");
            return rejectWithValue(
                error?.response?.data?.message || error?.message || "Failed to mark all as read"
            );
        }
    }

);
